"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_PUSH_ICON_LABELS = exports.EVENT_PUSH_ICONS = void 0;
exports.resolveActiveMessages = resolveActiveMessages;
exports.resolveMessageHistory = resolveMessageHistory;
exports.resolveActiveMessageForIcon = resolveActiveMessageForIcon;
exports.hasActivePacePushMessage = hasActivePacePushMessage;
exports.EVENT_PUSH_ICONS = [
    'stopwatch',
    'lightning',
    'score',
    'sunset',
    'info',
];
exports.EVENT_PUSH_ICON_LABELS = {
    stopwatch: 'Pace',
    lightning: 'Lightning',
    score: 'Score',
    sunset: 'Daylight',
    info: 'Info',
};
function isLegacyGlobalClear(msg) {
    return msg.message === '' && msg.clearScope !== 'icon';
}
function sortByPushedAt(messages) {
    return [...messages].sort((a, b) => a.pushedAt.localeCompare(b.pushedAt));
}
/** Latest legacy global clear boundary (blank message without clearScope: 'icon'). */
function resolveGlobalClearBoundary(messages) {
    const globalClears = messages.filter(isLegacyGlobalClear);
    return globalClears.length > 0 ? globalClears[globalClears.length - 1].pushedAt : null;
}
function resolvePerIconClearBoundary(messages, icon) {
    const iconClears = messages.filter(msg => msg.message === '' && msg.icon === icon && msg.clearScope === 'icon');
    return iconClears.length > 0 ? iconClears[iconClears.length - 1].pushedAt : null;
}
function isAfterBoundary(pushedAt, boundary) {
    return boundary === null || pushedAt > boundary;
}
/**
 * Resolve active messages — at most one per icon slot (0–5 total).
 * Optional isTargeted filter applies before resolution (live scoring).
 */
function resolveActiveMessages(messages, isTargeted) {
    const source = (messages ?? []).filter(msg => !isTargeted || isTargeted(msg));
    if (source.length === 0)
        return [];
    const sorted = sortByPushedAt(source);
    const globalClearBoundary = resolveGlobalClearBoundary(sorted);
    const active = [];
    for (const icon of exports.EVENT_PUSH_ICONS) {
        const iconMessages = sorted.filter(msg => msg.icon === icon);
        if (iconMessages.length === 0)
            continue;
        const perIconClearBoundary = resolvePerIconClearBoundary(sorted, icon);
        const effectiveBoundary = [globalClearBoundary, perIconClearBoundary]
            .filter((b) => b !== null)
            .sort()
            .pop() ?? null;
        const activeForIcon = iconMessages
            .filter(msg => msg.message !== '' && isAfterBoundary(msg.pushedAt, effectiveBoundary))
            .pop();
        if (activeForIcon) {
            active.push(activeForIcon);
        }
    }
    return active.sort((a, b) => a.pushedAt.localeCompare(b.pushedAt));
}
/** Full history newest-first for admin display. */
function resolveMessageHistory(messages) {
    if (!messages || messages.length === 0)
        return [];
    return [...messages].sort((a, b) => b.pushedAt.localeCompare(a.pushedAt));
}
/** Active message for a specific icon slot, if any. */
function resolveActiveMessageForIcon(messages, icon, isTargeted) {
    return resolveActiveMessages(messages, isTargeted).find(msg => msg.icon === icon) ?? null;
}
/** True when a targeted Pace (stopwatch) push message is currently active. */
function hasActivePacePushMessage(messages) {
    return messages.some((msg) => msg.icon === 'stopwatch');
}
